import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { AssignmentStudentStoreModel } from './assignment-student.model';

export type AssignmentStudentState = EntityState<AssignmentStudentStoreModel>;

@Injectable({ providedIn: 'root' })
export class AssignmentStudentStore extends EntityStore<AssignmentStudentState, AssignmentStudentStoreModel, 'student_id'> {
  constructor() {
    super({ name: 'assignment-students', idKey: 'student_id' });
  }
}
